import { IconApi } from '@components/icons/api';
import { IconDropside } from '@components/icons/dropside';
import { IconHelp } from '@components/icons/help';
import { IconSupport } from '@components/icons/support';
import { IconTada } from '@components/icons/tada';
import { Nav } from '@components/nav';
import { useIntercom } from '@hooks/use-intercom';
import { useScopedTranslate } from '@locale/translate';

const helpCenterUrl = 'https://help.journeys.50skills.app/en/';
const apiDocsUrl = 'https://docs.50skills.app/journeys';
const newsUrl = 'https://eu.intercom.news/50skills';

export const SupportMenu = () => {
  const { t } = useScopedTranslate(locale);
  const { showMessenger, isEnabled: isIntercomEnabled } = useIntercom();
  return (
    <Nav.Menu icon={<IconSupport size={16} />} label={t('support')} iconRight={<IconDropside />}>
      {isIntercomEnabled && (
        <Nav.MenuItem icon={<IconSupport />} label={t('helpchat')} onSelect={showMessenger} />
      )}
      <Nav.MenuItemLink icon={<IconHelp />} label={t('helpCenter')} to={helpCenterUrl} isExternal />
      <Nav.MenuItemLink icon={<IconApi />} label={t('apiDocs')} to={apiDocsUrl} isExternal />
      <Nav.MenuItemLink icon={<IconTada />} label={t('news')} to={newsUrl} isExternal />
    </Nav.Menu>
  );
};

const locale = {
  en: {
    support: 'Support',
    helpchat: 'Support chat',
    helpCenter: 'Help Center',
    apiDocs: 'API Docs',
    news: 'News',
  },
};
